import { createReducer } from '@reduxjs/toolkit'
import Status from '@constants/request_statuses.ts'
import ActionTypes from '@constants/action_types.js'

const initialState = {
  embedKeyLoadStatus: Status.IDLE,
}

export const timelineShow = createReducer(initialState, builder => {
  builder
    .addCase(ActionTypes.LOAD_EMBED_KEY_START, (state, action) => updateEmbedKeyLoadStatus(state, Status.LOADING))
    .addCase(ActionTypes.LOAD_EMBED_KEY_SUCCESS, (state, action) => updateEmbedKeyLoadStatus(state, Status.SUCCEEDED))
    .addCase(ActionTypes.LOAD_EMBED_KEY_FAIL, (state, action) => updateEmbedKeyLoadStatus(state, Status.FAILED))
})

export default timelineShow

function updateEmbedKeyLoadStatus(state, newStatus) {
  state.embedKeyLoadStatus = newStatus
  return state
}
